export default __webpack_public_path__ + "static/media/blau.90947b20.png";